require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./badezimmergestaltung.json") })
        }
      }, "path---badezimmergestaltung");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---badezimmergestaltung!./.cache/json/badezimmergestaltung.json
// module id = 448
// module chunks = 231608221292675